const RESERVED_KEYS = ['date', 'market']

/**
 * Resolves the main provider key inside `charDataMarket`.
 *
 * The backend names that key after the provider itself (`"europcar"`, ...), so
 * it has to be found by the `isMainData` flag rather than by name.
 */
export const findMainKey = (marketChartData = []) => {
	for (const row of marketChartData) {
		const key = Object.keys(row).find(k =>
			!RESERVED_KEYS.includes(k) && row[k]?.isMainData)

		if (key) return key
	}

	return null
}

/**
 * Flattens `charDataMarket` into the flat rows amcharts expects.
 *
 * `market` is absent on days with no competitor rate, so band and average come
 * back as `undefined` and the series break instead of dropping to zero.
 */
export const buildMarketBandData = (marketChartData = [], mainKey) => marketChartData.map(row => ({
	date: row.date,
	main: row[mainKey]?.price,
	rank: row[mainKey]?.pricePosition,
	// Brands actually quoting that date, so a rank reads against what was really
	// on offer instead of against the full tracked set.
	brands: row.market?.brands,
	minPrice: row.market?.minPrice,
	maxPrice: row.market?.maxPrice,
	avgPrice: row.market?.avgPrice,
}))
